// mission-archive-dirty-paths.ts
//
// The "bẩn" filter of `avatar autopilot archive` (phase-02 Req 3, H1), split
// out of mission-archive.ts for the 200-line budget (re-review 2026-09-26).
// From `init` to the bootstrap commit of the first `run`, the worktree is
// dirty BY CONSTRUCTION — bootstrap tickets under `.avatar/`, pack/settings/
// guard-flag under `.claude/` (both untracked), and a `.gitignore` append —
// all controller/init output, reproducible by re-running `init`, never a
// user's work. Excluding them lets a mission that was `init`'d but never
// `run` archive without `--force`.

/** Controller/init-owned path prefixes — excluded from the "dirty" count (H1). */
export const ARCHIVE_IGNORED_DIRTY_PREFIXES = [".avatar/", ".claude/"] as const;
const ARCHIVE_IGNORED_DIRTY_EXACT_PATH = ".gitignore";

function isIgnoredDirtyPath(path: string): boolean {
  if (path === ARCHIVE_IGNORED_DIRTY_EXACT_PATH) return true;
  return ARCHIVE_IGNORED_DIRTY_PREFIXES.some((prefix) => path.startsWith(prefix));
}

/**
 * Counts entries in `git status --porcelain=v1 -z --untracked-files=all`
 * output that are NOT init/controller-owned (H1). Pure — no git call — so
 * refusal tests can feed synthetic porcelain text. Format: `XY <path>\0`,
 * NUL-separated; rename/copy entries (`R`/`C`) carry a SECOND NUL-separated
 * field (old path) and count as dirty if either path is outside the ignored set.
 */
export function countUserDirtyPaths(porcelainZ: string): number {
  const fields = porcelainZ.split("\0").filter((f) => f.length > 0);
  let dirty = 0;
  let i = 0;
  while (i < fields.length) {
    const entry = fields[i] as string;
    const statusCode = entry.slice(0, 2);
    const path = entry.slice(3);
    i++;
    let oldPath: string | undefined;
    if ((statusCode[0] === "R" || statusCode[0] === "C") && i < fields.length) {
      oldPath = fields[i];
      i++;
    }
    const allIgnored =
      isIgnoredDirtyPath(path) && (oldPath === undefined || isIgnoredDirtyPath(oldPath));
    if (!allIgnored) dirty++;
  }
  return dirty;
}

/** `git status` failing because there is no repository at all — nothing to protect, archive may proceed. */
export function isNotAGitRepositoryError(stderr: string): boolean {
  return /not a git repository/i.test(stderr);
}
